import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { Download, ExternalLink, Mail, Phone, MapPin, Users, Award, FileText, ArrowRight } from "lucide-react";
import { useState } from "react";
import CountUp from "@/components/CountUp";

const ORGANI = [
  { nome: "Luca Stevanato", ruolo: "Presidente" },
  { nome: "Paolo Barberini", ruolo: "Direttore Generale" },
  { nome: "Romolo Guasco", ruolo: "Consigliere" },
  { nome: "Simona Petrozzi", ruolo: "Consigliere" },
  { nome: "Antonella Pugliese", ruolo: "Direttrice Commerciale" },
];

const DOCUMENTI_QUALITA = [
  { label: "Politica della Qualità", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/09/POLITICA-QUALITA-FIRMATA.pdf" },
  { label: "MOG Promo.Ter – Parte generale", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/03/Parte-Generale_Promoter.pdf" },
  { label: "Regolamento Whistleblowing", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/05/Promoter_Regolamento-Whistleblowing_29.05.24.pdf" },
  { label: "Codice Etico", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/03/All.1-Codice-Etico-Promoter.pdf" },
];

const DOCUMENTI_PARITA = [
  { label: "Politica Parità di genere", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/12/Politica-parita-di-genere.pdf" },
  { label: "Modulo segnalazioni molestie", url: "https://forms.gle/2A8fcV5Atn9dPwhD8" },
  { label: "Manifesto della gentilezza", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/12/MANIFESTO-GENTILEZZA.pdf" },
  { label: "Volantino no molestie", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/12/VOLANTINO-no-molestie.pdf" },
];

const CERTIFICAZIONI = [
  "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Certificazioni-Sportelli-di-Confcommercio-Roma1.png",
  "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Certificazioni-Sportelli-di-Confcommercio-Roma2.png",
  "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Certificazioni-Sportelli-di-Confcommercio-Roma3.png",
  "/local-assets/uniter-iso21001-lilla-accredia.webp",
  "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Certificazioni-Sportelli-di-Confcommercio-Roma5.png",
  "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Certificazioni-Sportelli-di-Confcommercio-Roma6.png",
];

const TEAM_AREE = [
  {
    titolo: "Direzione",
    persone: [
      { nome: "Paolo Barberini", ruolo: "Direttore Generale", email: "p.barberini@confcommercioroma.it", tel: "06.68437801" },
      { nome: "Antonella Pugliese", ruolo: "Direttore Operativo", email: "a.pugliese@confcommercioroma.it", tel: "06.68437603" },
    ],
  },
  {
    titolo: "Area Commerciale",
    persone: [
      { nome: "Lucio Chiariello", ruolo: "Referente Commerciale", email: "l.chiariello@confcommercioroma.it", tel: "06.68437606" },
      { nome: "Simone Proietti", ruolo: "Referente Commerciale", email: "s.proietti@confcommercioroma.it", tel: "06.68437530" },
    ],
  },
  {
    titolo: "Area Servizi",
    persone: [
      { nome: "Paolo Milanese", ruolo: "Tecnico Prevenzione e Sicurezza nei Luoghi di Lavoro e Igiene degli Alimenti", email: "p.milanese@confcommercioroma.it", tel: "06.68437266" },
      { nome: "Valentina Masella", ruolo: "Tecnico Prevenzione e Sicurezza nei Luoghi di Lavoro e Igiene degli Alimenti", email: "v.masella@confcommercioroma.it", tel: "06.68437560" },
      { nome: "Serena Ledderucci", ruolo: "Tecnico Prevenzione e Sicurezza nei Luoghi di Lavoro", email: "s.ledderucci@confcommercioroma.it", tel: "06.68437454" },
      { nome: "Roberta Falcomer", ruolo: "Referente Area Servizi", email: "r.falcomer@confcommercioroma.it", tel: "06.68437555" },
      { nome: "Filippo Giuffrè", ruolo: "Tecnico Prevenzione e Sicurezza nei Luoghi di Lavoro e Privacy Officer", email: "f.giuffre@confcommercioroma.it", tel: "06.68437604" },
    ],
  },
  {
    titolo: "Area Formazione",
    persone: [
      { nome: "Adele Eccellente", ruolo: "Referente Area Formazione", email: "a.eccellente@confcommercioroma.it", tel: "06.68437457" },
      { nome: "Martina Menghi", ruolo: "Referente Area Formazione", email: "m.menghi@confcommercioroma.it", tel: "06.68437227" },
      { nome: "Maria Laura D'Andrea", ruolo: "Referente Area Formazione", email: "ml.dandrea@confcommercioroma.it", tel: "06.68437311" },
      { nome: "Federica Ferrillo", ruolo: "Referente Area Formazione", email: "f.ferrillo@confcommercioroma.it", tel: "06.68437240" },
      { nome: "Marta Abbondanza", ruolo: "Referente Area Formazione", email: "m.abbondanza@confcommercioroma.it", tel: "06.68437335" },
      { nome: "Chiara Mapelli", ruolo: "Referente Area Formazione", email: "c.mapelli@confcommercioroma.it", tel: "06.68437452" },
      { nome: "Eloisa Mucci", ruolo: "Referente Area Formazione – Rendicontazione", email: "e.mucci@confcommercioroma.it", tel: "06.68437455" },
      { nome: "Elisabetta Tomei", ruolo: "Referente Area Formazione – Rendicontazione", email: "e.tomei@confcommercioroma.it", tel: "06.68437451" },
      { nome: "Giulia Tomassoni", ruolo: "Referente Area Formazione Abilitante, Progetti di Sviluppo e Segreteria Organizzativa", email: "g.tomassoni@confcommercioroma.it", tel: "06.68437610" },
    ],
  },
];

const CLIENTI_PROMOTER = [
  { nome: "American Express Italia S.p.A.", logo: null },
  { nome: "FIDAL – Federazione Italiana di Atletica Leggera", logo: null },
  { nome: "Palombini Ricevimenti S.r.l.", logo: null },
  { nome: "Dan John Italia S.p.A.", logo: null },
  { nome: "Fondazione Bioparco di Roma", logo: null },
  { nome: "Risorse per Roma S.p.A.", logo: null },
  { nome: "Herbalife Italia S.p.A.", logo: null },
];

const TABS = ["Politiche della qualità", "Parità di genere"];

export default function PromoterPage() {
  const [activeTab, setActiveTab] = useState("Politiche della qualità");

  return (
    <main id="main-content" data-testid="promoter-page">
      {/* Hero */}
      <section className="bg-[var(--confcom-blue)] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HeroBreadcrumb />
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Promo.Ter</h1>
            <p className="text-lg text-white/80 mt-3 max-w-3xl">Società per la Promozione e lo Sviluppo del Terziario di Confcommercio Roma.</p>
            <Link
              to="/servizi#assistenza"
              className="mt-6 inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-7 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity text-sm"
              data-testid="promoter-hero-cta-servizi"
            >
              Scopri i nostri Servizi <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-xl text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] leading-relaxed mb-6">
                Promo.Ter – Società per la Promozione e lo Sviluppo del Terziario di Confcommercio Roma – lavora con la tua impresa attraverso l'offerta di servizi e di formazione dedicata.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                <strong className="text-[var(--confcom-text-primary)]">Promo.Ter lavora con le imprese e per le imprese.</strong>
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Attraverso le Business-Unit di Servizi e Formazione, Promo.Ter offre un <strong className="text-[var(--confcom-text-primary)]">global service</strong> strategico e affianca le aziende in percorsi di crescita e <strong className="text-[var(--confcom-text-primary)]">miglioramento delle performance.</strong>
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                L'obiettivo è diventare un partner affidabile e un punto di riferimento costante per permettere alle aziende di concentrarsi su ciò che conta davvero: far crescere il proprio business.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
                Grazie a un'attività di ricerca costante e capillare, supportiamo le imprese nell'<strong className="text-[var(--confcom-text-primary)]">individuazione di finanziamenti</strong> e strumenti adeguati a soddisfare ogni esigenza.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <img src="/promoter-hero.png" alt="Promo.Ter - Formazione e servizi" className="w-full max-w-sm rounded-2xl object-contain" />
            </div>
          </div>
        </div>
      </section>

      {/* Numeri */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1920&q=60&auto=format" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.92)" }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <h2 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-10 text-center">I numeri</h2>
          <div className="grid grid-cols-4 gap-4 text-center">
            {[
              { to: 1239,  label: "Imprese assistite" },
              { to: 1174,  label: "Corsi erogati" },
              { to: 13734, label: "Persone formate" },
              { to: 14252, label: "Ore di docenza" },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/[0.08] backdrop-blur-sm border border-white/10 rounded-2xl p-8">
                <div className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed']">
                  <CountUp to={stat.to} />
                </div>
                <div className="text-sm text-white/60 mt-2">{stat.label}</div>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-4 mt-10">
            <a href="https://www.confcommercioroma.it/wp-content/uploads/2025/06/PROMO.TER_brochure_digital-2025V4.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm" data-testid="promoter-brochure">
              <Download size={16} aria-hidden="true" /> Sfoglia la brochure
            </a>
          </div>
        </div>
      </section>

      {/* Box Formazione e Servizi */}
      <section id="servizi" className="py-16 bg-white scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">

          {/* Box 1 – Formazione: testo sx, foto dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Cresci con noi</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 mb-5 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Scopri la formazione</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Promo.Ter eroga corsi obbligatori, abilitanti e di aggiornamento professionale per le imprese del terziario. Dal corso sicurezza sul lavoro all'HACCP, dalla privacy agli agenti immobiliari, fino alla formazione finanziata tramite fondi interprofessionali.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">
                Con Promo.Ter accedi anche al <strong className="text-[var(--confcom-text-primary)]">credito d'imposta 4.0</strong> per la formazione del personale e ai programmi di <strong className="text-[var(--confcom-text-primary)]">formazione finanziata</strong> tramite For.Te e Fon.Dir.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link to="/formazione" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                  Scopri la formazione <ArrowRight size={16} aria-hidden="true" />
                </Link>
                <Link to="/formazione/corsi-in-partenza" className="inline-flex items-center gap-2 border border-[var(--confcom-blue)] text-[var(--confcom-blue)] px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                  Calendario Corsi <ArrowRight size={16} aria-hidden="true" />
                </Link>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="/promoter-formazione.jpg"
                alt="Aula di formazione con docente e partecipanti"
                className="w-full h-[340px] object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Box 2 – Servizi: foto sx, testo dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-2xl overflow-hidden shadow-lg order-2 lg:order-1">
              <img
                src="/promoter-servizi.jpg"
                alt="Commerciante e consulente che si stringono la mano"
                className="w-full h-[340px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Supporto concreto</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 mb-5 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Scopri i servizi</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Promo.Ter offre consulenza specializzata e assistenza tecnica alle imprese associate. Dai servizi di apertura attività alla gestione delle pratiche amministrative, dalla consulenza fiscale e del lavoro all'accesso a finanziamenti pubblici e privati.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">
                Il nostro team di esperti affianca l'imprenditore in ogni fase della vita aziendale, con <strong className="text-[var(--confcom-text-primary)]">soluzioni personalizzate</strong> e un approccio orientato ai risultati.
              </p>
              <Link to="/servizi" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                Scopri i servizi <ArrowRight size={16} aria-hidden="true" />
              </Link>
            </div>
          </div>

        </div>
      </section>

      {/* Il Team */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">Il Team</h2>

          {TEAM_AREE.map((area) => (
            <div key={area.titolo} className="mb-12 last:mb-0">
              <h3 className="text-base font-bold text-[var(--confcom-blue)] uppercase tracking-wide font-['Encode_Sans_Semi_Condensed'] mb-4">
                {area.titolo}
              </h3>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {area.persone.map((p, i) => (
                  <div key={`${area.titolo}-${i}`} className="bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:shadow-md transition-shadow" data-testid="promoter-team-card">
                    <div className="aspect-[4/3] bg-[var(--confcom-bg-blue-light)] flex items-center justify-center">
                      <Users size={48} className="text-[var(--confcom-blue)]/40" aria-hidden="true" />
                    </div>
                    <div className="p-4">
                      <p className="font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">{p.nome}</p>
                      {p.ruolo && <p className="text-sm text-[var(--confcom-blue)] font-medium mt-1 leading-snug">{p.ruolo}</p>}
                      <div className="space-y-1.5 mt-3">
                        {p.email && (
                          <a href={`mailto:${p.email}`} className="flex items-center gap-2 text-xs text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] transition-colors break-all">
                            <Mail size={12} className="shrink-0" aria-hidden="true" /> {p.email}
                          </a>
                        )}
                        {p.tel && (
                          <a href={`tel:+39${p.tel.replace(/\./g, "")}`} className="flex items-center gap-2 text-xs text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] transition-colors">
                            <Phone size={12} className="shrink-0" aria-hidden="true" /> {p.tel}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Banner 7/7 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
        <div className="bg-[var(--confcom-blue)] rounded-2xl px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 bg-white/15 rounded-full flex items-center justify-center shrink-0">
              <Phone size={24} className="text-white" aria-hidden="true" />
            </div>
            <div>
              <p className="text-white font-bold text-lg font-['Encode_Sans_Semi_Condensed']">Assistenza dedicata</p>
              <p className="text-white/75 text-sm mt-0.5">Il team Promo.Ter è a tua disposizione per supportarti in ogni esigenza.</p>
            </div>
          </div>
          <a href="mailto:commerciale.promoter@confcommercioroma.it" className="shrink-0 inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-bold text-sm hover:opacity-90 transition-opacity whitespace-nowrap">
            Scrivici ora <ArrowRight size={16} aria-hidden="true" />
          </a>
        </div>
      </div>

      {/* Tabs: Qualità / Parità */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Tab nav */}
          <div className="flex flex-wrap gap-2 mb-10 border-b border-[var(--confcom-border)]">
            {TABS.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-3 text-sm font-semibold font-['Encode_Sans_Semi_Condensed'] border-b-2 -mb-[2px] transition-colors ${
                  activeTab === tab
                    ? "border-[var(--confcom-blue)] text-[var(--confcom-blue)]"
                    : "border-transparent text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)]"
                }`}
                data-testid={`tab-${tab.toLowerCase().replace(/\s/g, "-")}`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab: Qualità */}
          {activeTab === "Politiche della qualità" && (
            <div data-testid="tab-content-qualita">
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Politiche della qualità e modello organizzativo</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Promo.Ter è <strong className="text-[var(--confcom-text-primary)]">accreditata presso la Regione Lazio come Ente per la formazione continua e superiore</strong>, presso i Fondi Interprofessionali (<strong className="text-[var(--confcom-text-primary)]">For.Te e Fon.Dir</strong>) come Ente Attuatore e Presentatore; l'agenzia formativa di <strong className="text-[var(--confcom-text-primary)]">Ebit Lazio, Ente Bilaterale Terziario del Lazio</strong>.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-8">
                È inoltre <strong className="text-[var(--confcom-text-primary)]">certificata</strong> secondo le norme <strong className="text-[var(--confcom-text-primary)]">UNI EN ISO 9001, ISO 45001, ISO 14001, UNI PDR 125</strong> e <strong className="text-[var(--confcom-text-primary)]">UNI ISO 21001, come ESG come impresa sostenibile e come impresa rosa.</strong>
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                {DOCUMENTI_QUALITA.map((doc) => (
                  <a key={doc.label} href={doc.url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all">
                    <div className="w-12 h-12 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[var(--confcom-blue)] transition-colors">
                      <FileText size={22} className="text-[var(--confcom-blue)] group-hover:text-white transition-colors" aria-hidden="true" />
                    </div>
                    <span className="flex-1 text-sm font-medium text-[var(--confcom-text-primary)] group-hover:text-[var(--confcom-blue)] transition-colors">{doc.label}</span>
                    <ExternalLink size={16} className="text-[var(--confcom-text-muted)] group-hover:text-[var(--confcom-blue)] transition-colors shrink-0" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Tab: Parità di genere */}
          {activeTab === "Parità di genere" && (
            <div data-testid="tab-content-parita">
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">Politica parità di genere</h2>
              <div className="grid sm:grid-cols-2 gap-4">
                {DOCUMENTI_PARITA.map((doc) => (
                  <a key={doc.label} href={doc.url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all">
                    <div className="w-12 h-12 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[var(--confcom-blue)] transition-colors">
                      <Award size={22} className="text-[var(--confcom-blue)] group-hover:text-white transition-colors" aria-hidden="true" />
                    </div>
                    <span className="flex-1 text-sm font-medium text-[var(--confcom-text-primary)] group-hover:text-[var(--confcom-blue)] transition-colors">{doc.label}</span>
                    <ExternalLink size={16} className="text-[var(--confcom-text-muted)] group-hover:text-[var(--confcom-blue)] transition-colors shrink-0" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Certificazioni */}
      <section className="py-12 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-4 text-center">Le nostre certificazioni</h2>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-3 max-w-3xl mx-auto text-center">
            Le certificazioni riflettono l'impegno costante nell'offrire un servizio impeccabile, garantendo standard elevati in ogni aspetto del lavoro.
          </p>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-8 max-w-3xl mx-auto text-center">
            Qualità, sicurezza, ambiente e inclusività sono valori fondamentali che permettono di soddisfare le esigenze dei clienti con efficienza, affidabilità e competenza.
          </p>
          <div className="grid grid-cols-7 gap-4">
            {CERTIFICAZIONI.map((src, i) => (
              <div key={i} className="bg-white rounded-xl p-3 shadow-sm border border-[var(--confcom-border)] aspect-square flex items-center justify-center">
                <img src={src} alt={`Certificazione ${i + 1}`} className="w-full h-full object-contain" loading="lazy" />
              </div>
            ))}
            <div className="bg-white rounded-xl p-3 shadow-sm border border-[var(--confcom-border)] aspect-square flex items-center justify-center">
              <img src="https://www.confcommercioroma.it/wp-content/uploads/2026/03/LOGO_IMPRESA_ROSA_COL-1-300x238.jpg" alt="Impresa Rosa Regione Lazio" className="w-full h-full object-contain" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Brand / Clienti */}
      <section className="py-16 bg-[#F5F8FC]" data-testid="promoter-brand-clienti">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Hanno scelto Promo.Ter</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">
              I clienti con cui collaboriamo
            </h2>
            <p className="text-sm text-[var(--confcom-text-secondary)] mt-3 max-w-2xl mx-auto">
              Aziende del territorio e grandi gruppi che si affidano ai nostri servizi di consulenza e formazione.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {CLIENTI_PROMOTER.map((c, i) => (
              <div
                key={i}
                className="aspect-[3/2] bg-white rounded-xl border border-[var(--confcom-border)] flex flex-col items-center justify-center gap-2 px-3 py-3 hover:shadow-md hover:border-[var(--confcom-blue)]/30 transition-all"
                data-testid={`promoter-brand-${i}`}
              >
                {c.logo && (
                  <img src={c.logo} alt={c.nome} className="max-h-10 max-w-[85%] object-contain" loading="lazy" />
                )}
                <span className="text-sm font-bold text-[var(--confcom-text-primary)] text-center leading-tight">
                  {c.nome}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Contatti */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1920&q=60&auto=format" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.92)" }} />
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per maggiori informazioni</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3">Contattaci</h2>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 mb-10">
            {/* Sede Legale e Operativa */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <MapPin size={16} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Sede Legale e Operativa</h3>
              </div>
              <p className="text-white/90 text-sm leading-relaxed mb-3">Via Marco e Marcelliano 45 – 00147 Roma</p>
              <div className="space-y-1.5 text-sm">
                <div className="flex items-center gap-2 text-white/80">
                  <Phone size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                  <a href="tel:+390668437606" className="hover:text-white transition-colors">Tel: 06 68437606</a>
                  <span className="text-white/40">|</span>
                  <span className="text-white/70">Fax 06 68210405</span>
                </div>
                <div className="flex items-center gap-2 text-white/80">
                  <Mail size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                  <a href="mailto:promoter@confcommercioroma.it" className="hover:text-white transition-colors">promoter@confcommercioroma.it</a>
                </div>
                <div className="flex items-center gap-2 text-white/80">
                  <Mail size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                  <a href="mailto:promoterroma@legalmail.it" className="hover:text-white transition-colors">PEC: promoterroma@legalmail.it</a>
                </div>
              </div>
            </div>

            {/* Sede Didattica */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <MapPin size={16} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Sede Didattica</h3>
              </div>
              <p className="text-white/90 text-sm leading-relaxed mb-3">Via Marco e Marcelliano 45 – 00147 Roma</p>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <Phone size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437462" className="hover:text-white transition-colors">Tel: 06 68437462</a>
              </div>
            </div>

            {/* Area Commerciale */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Area Commerciale</h3>
              </div>
              <div className="space-y-1.5 text-sm">
                <div className="flex items-center gap-2 text-white/80">
                  <Mail size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                  <a href="mailto:commerciale.promoter@confcommercioroma.it" className="hover:text-white transition-colors">commerciale.promoter@confcommercioroma.it</a>
                </div>
                <div className="flex items-center gap-2 text-white/80">
                  <Phone size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                  <a href="tel:+390668437606" className="hover:text-white transition-colors">Tel: 06 68437 606-530</a>
                </div>
              </div>
            </div>

            {/* Segreteria Organizzativa */}
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
              <div className="flex items-center gap-2 mb-4">
                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Segreteria Organizzativa</h3>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <Phone size={13} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437610" className="hover:text-white transition-colors">Tel: 06 68437 610-606</a>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeI0Vqu99GYZzw4uOdVyGP_3XYclxTdPfeVgPSQr3pdtN0kKQ/viewform" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-8 py-4 rounded-md font-bold hover:opacity-90 transition-opacity shadow-lg" data-testid="promoter-form-link">
              <ExternalLink size={18} aria-hidden="true" /> Vuoi essere ricontattato?
            </a>
            <a href="https://www.confcommercioroma.it/wp-content/uploads/2025/06/PROMO.TER_brochure_digital-2025V4.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-md font-semibold hover:opacity-90 transition-opacity" data-testid="promoter-brochure">
              <Download size={18} aria-hidden="true" /> Sfoglia la brochure
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
